export default "__VITE_ASSET__Tmjeevv0__"